export function resetOverlay(): void {
  const root = document.getElementById('overlay');
  if (root) root.innerHTML = '';
}

export function overlayRoot(): HTMLElement | null {
  return document.getElementById('overlay');
}
